<div class="frontpage-widget cover-image-mose-gray">
    <div class="whitebox gray">
        <div class="container">
            <p class="text-muted">RISIKOVURDERING <i class="fa fa-chevron-right"></i></p>
            <h2 i18n>Vælg beregningsmodel</h2>
            <p class="mt-2 vd-text-muted">Vælg beregningsmodel (1-5) for den vertikale stoftransport fra forureningskilde til grundvand. Den valgte beregningsmodel for den vertikale transport kobles med en model for den horisontale stoftransport i grundvandsmagasinet. </p>
            <p class="mt-2 vd-text-muted">Transporten i grundvandsmagasinet beskrives som 3D horisontal transport under hensyntagen til advektion, dispersion og infiltration til forureningsfanen.  Ved tynde grundvandsmagasiner anvendes en 2D-løsning, da fanens udbredelse nedadtil vil være begrænset. Alle modeller er stationære, hvilket vil sige at koncentrationerne er konstante over tid, men ikke over sted. Der kan tages højde for nedbrydning både under den vertikale og horisontale transport.</p>
        </div>
    </div>
</div>

<div class="container">
    <!--Model 1-->
    <div class="row mt-5">
        <div class="col-lg-1"></div>
        <div class="col-sm-12 col-lg-7">
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <h5 i18n>
                        <span><span class="model-indicator lg"><i class="model-icon"></i><span class="model-number">1</span></span>  {{calculationModelNames[1]}}</span>
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <p i18n>Modellen beskriver en forureningskilde beliggende i vandmættet ler, der overlejrer et grundvandsmagasin. Den vertikale forureningstransport til grundvandet beskrives ved advektion og dispersion.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <button (click)="selectModel(calculationModelType.ModelI)" class="btn btn-secondary">Vælg <span class="fa fa-play"></span></button>
                </div>
            </div>
        </div>
        
        <div class="col-sm-12 col-lg-3">
            <div class="image-card model-image-card mx-auto" (click)="selectModel(calculationModelType.ModelI)">
                <img class="helper-img" src="assets/Model1_icon2.png" />
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-sm-12 col-lg-11 mx-auto">
            <hr/>
        </div>
    </div>

    <!--Model 2-->
    <div class="row mt-2">
        <div class="col-lg-1"></div>
        <div class="col-sm-12 col-lg-7">
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <h5>
                        <span><span class="model-indicator lg"><i class="model-icon"></i><span class="model-number">2</span></span>  {{calculationModelNames[2]}}</span>
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <p i18n>Modellen beskriver en forureningskilde beliggende i opsprækket ler, der overlejrer et grundvandsmagasin. Forureningsspredningen sker i modellen ved advektiv transport i sprækkerne og diffusion i lermatricen.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <button (click)="selectModel(calculationModelType.ModelII)" class="btn btn-secondary">Vælg <span class="fa fa-play"></span></button>
                </div>
            </div>
        </div>
        
        <div class="col-sm-12 col-lg-3">
            <div class="image-card model-image-card mx-auto" (click)="selectModel(calculationModelType.ModelII)">
                <img class="helper-img" src="assets/Model2_icon2.png" />
                
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-sm-12 col-lg-11 mx-auto">
            <hr/>
        </div>
    </div>
    
    <!--Model 3-->
    <div class="row mt-2">
        <div class="col-lg-1"></div>
        <div class="col-sm-12 col-lg-7">
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <h5>
                        <span><span class="model-indicator lg"><i class="model-icon"></i><span class="model-number">3</span></span>  {{calculationModelNames[3]}}</span>
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <p i18n>Modellen beskriver en forureningskilde beliggende i umættet zone og som overlejrer et frit grundvandsmagasin. Forureningsspredningen sker ved diffusion i gasfasen samt ved advektion og dispersion i vandfasen (3D-løsning). Forureningsarealet ved toppen af magasinet vil dermed være større end ved forureningskilden og koncentrationerne vil aftage ud mod kanten af det forurenede areal.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <button (click)="selectModel(calculationModelType.ModelIII)" class="btn btn-secondary">Vælg <span class="fa fa-play"></span></button>
                </div>
            </div>
        </div>
        
        <div class="col-sm-12 col-lg-3">
            <div class="image-card model-image-card mx-auto" (click)="selectModel(calculationModelType.ModelIII)">
                <img class="helper-img" src="assets/Model3_icon2.png" />
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-sm-12 col-lg-11 mx-auto">
            <hr/>
        </div>
    </div>
    
    <!--Model 4-->
    <div class="row mt-2">
        <div class="col-lg-1"></div>
        <div class="col-sm-12 col-lg-7">
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <h5 i18n>
                        <span><span class="model-indicator lg"><i class="model-icon"></i><span class="model-number">4</span></span>  {{calculationModelNames[4]}}</span>
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <p i18n>Modellen beskriver en forureningskilde beliggende i umættet zone dækket af en vandtæt overflade f.eks. en bygning. Forureningstransporten til grundvandet sker derfor udelukkende ved gasdiffusion. Kildeområdet antages at være cirkulært og forureningen spreder sig radiært ud fra kildeområdet. Koncentrationerne vil derfor variere over sted.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <button (click)="selectModel(calculationModelType.ModelIV)" class="btn btn-secondary">Vælg <span class="fa fa-play"></span></button>
                </div>
            </div>
        </div>
        
        <div class="col-sm-12 col-lg-3">
            <div class="image-card model-image-card mx-auto" (click)="selectModel(calculationModelType.ModelIV)">
                <img class="helper-img" src="assets/Model4_icon2.png" />
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-sm-12 col-lg-11 mx-auto">
            <hr/>
        </div>
    </div>
    
    <!--Model 5-->
    <div class="row mt-2 mb-5">
        <div class="col-lg-1"></div>
        <div class="col-sm-12 col-lg-7">
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <h5>
                        <span><span class="model-indicator lg"><i class="model-icon"></i><span class="model-number">5</span></span>  {{calculationModelNames[5]}}</span>
                    </h5>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <p i18n>Modellen beskriver en forureningskilde beliggende lige over grundvandet. Det er dermed den simpleste model af de 5 modeller, da der ikke sker nogen vertikal transport udover den direkte forureningsflux til grundvandsmagasinet.</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12">
                    <button (click)="selectModel(calculationModelType.ModelV)" class="btn btn-secondary">Vælg <span class="fa fa-play"></span></button>
                </div>
            </div>
        </div>
        
        <div class="col-sm-12 col-lg-3">
            <div class="image-card model-image-card mx-auto" (click)="selectModel(calculationModelType.ModelV)">
                <span class="helper"></span>
                <img class="helper-img" src="assets/Model5_icon2.png" />
            </div>
        </div>
    </div>

</div>